import React from 'react';
import { Box, CircularProgress, Alert } from '@mui/material';
import { useProjects } from '../../hooks/useProjects';
import ProjectDocumentsDashboard from '../../components/administracion/ProjectDocumentsDashboard';

const ProyectoDocumentosPage = () => {
  const { projectsDocuments, error, isLoading } = useProjects();

  if (isLoading) return <CircularProgress />;
  if (error) return <Alert severity="error">Error al cargar proyectos documentos.</Alert>;

  return (
    <Box sx={{ p: 2 }}>
      <ProjectDocumentsDashboard
        windows={projectsDocuments}
        onReorder={(newOrder) => {
          console.log('Nuevo orden de proyectos documentos:', newOrder);
        }}
      />
    </Box>
  );
};

export default ProyectoDocumentosPage;